<!-- vue3模版代码 -->
<template>
  <div class="img-panel-wrapper" v-if="props.isShow">
    <div class="img-info-box flex-display flex-justify-start flex-align-center" >
        <div class="preview-box"  v-if="currentImg">
          <div v-if="currentImg.object_keys.indexOf('.mp4') === -1" class="centerP" style="height:100%" :style="restoreNum===3?'left:50%;top:50%':''">
            <div class="drag-title" style="height:100%">
              <img :src="currentImg.object_keys"  :style="{transform:'scale('+scaleNum+')',height:'100%'}" alt="">
            </div>
          </div>
            <video v-else :src="currentImg.object_keys" style="width:100%;height:100%;" controls></video>
          <div class="preview-btn" @click="handlePreview">
            <LeftCircleFilled style="font-size: 48px;color:#ffffff"/>
          </div>
          <div class="next-btn"  @click="handleNext">
            <RightCircleFilled style="font-size: 48px;color:#ffffff"/>
          </div>
        </div>
        <div class="img-preview-info-box">
          <div v-if="props.type === 'media'">
            <span class="f16 cf">详细信息</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">文件名称：</span>
                <span  class="f12 cf ml20">{{currentImg.file_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">任务名称：</span>
                <span  class="f12 cf ml20">{{currentImg.job_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">航线名称：</span>
                <span  class="f12 cf ml20">{{currentImg.fly_line_name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">拍摄负载：</span>
                <span  class="f12 cf ml20">{{currentImg.payload}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">拍摄时间：</span>
                <span  class="f12 cf ml20">{{currentImg.create_time}}</span>
              </div>
              <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">文件位置：</span>
                <!-- <img :src="mapPng" style="width: 16px;" alt=""> -->
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <imageMap :mapInfo="currentImg"/>
              </div>
          </div>
          <div v-if="props.type === 'alarm'">
            <span class="f16 cf">告警信息</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">账号名称：</span>
                <span  class="f12 cf ml20">{{currentImg.customerName}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">告警模型：</span>
                <span  class="f12 cf ml20">{{currentImg.modelName}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">告警时间：</span>
                <span  class="f12 cf ml20">{{currentImg.alarmDate}}</span>
              </div>
              <div class="flex-display flex-justify-between flex-align-center mt20" v-if="currentImg.lat !== '0.0'">
                <span class="f12 c9 ">文件位置：</span>
                <!-- <img :src="mapPng" style="width: 16px;" alt=""> -->
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== '0.0'">
                <imageMap :mapInfo="currentImg"/>
              </div>
          </div>
          <div v-if="props.type === 'point'">
            <span class="f16 cf">指点飞行详情</span>
              <div class="flex-display flex-justify-start flex-align-center mt20">
                <span class="f12 c9 ">名称：</span>
                <span  class="f12 cf ml20">{{currentImg.name}}</span>
              </div>
              <div class="flex-display flex-justify-start flex-align-center mt20" >
                <span class="f12 c9 ">文件大小</span>
                <span  class="f12 cf ml20">{{currentImg.size}}M</span>
              </div>
              <div class="map-box mt10" v-if="currentImg.lat !== 0">
                <imageMap :mapInfo="currentImg"/>
              </div>
          </div>
          <div class="close-btn" @click="closeImgPreview">
            <CloseOutlined style="font-size: 24px;color:#ffffff"/>
          </div>
        </div>
    </div>
    <div class="img-list-box flex-display flex-justify-center flex-align-end">
      <div class="list-scroll-box flex-display flex-justify-start flex-align-end">
          <div class="ml10 viewer-list" :class="currentIndex===index?'is-active-img':''"  v-for="(item,index) in imgSrcList"
              :key="item.object_keys" @click="handleImgPreview(index)">
              <div v-if="item.object_keys.indexOf('.mp4') === -1">
                <img  v-img-lazy="item.object_keys"  style="width:96px;height: 54px;border-radius: 8px;" alt="">
              </div>

              <video v-else :src="item.object_keys" style="width:96px;height: 54px;" ></video>
          </div>
      </div>
      <!-- 工具 -->
      <div class="tool-box flex-display flex-justify-center flex-align-center">
        <ZoomInOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="scaleImg('enlarge')"/>
        <ZoomOutOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="scaleImg('narrow')"/>
        <RedoOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="restoreImg()"/>
        <HighlightOutlined class="mr-20" style="color:#ffffff;font-size: 24px;" @click="handleMarkImg()" v-show="isSign"/>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, watch, defineComponent, onMounted, ref, defineProps, defineEmits } from 'vue'
import { message, Modal } from 'ant-design-vue'
import mapPng from '/@/assets/media/map.png'
import {
  LeftCircleFilled,
  RightCircleFilled,
  CloseOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RedoOutlined,
  HighlightOutlined
} from '@ant-design/icons-vue'
import imageMap from './imageMap.vue'
import { flagMisreportByAlgorithmAlarm, setAlarmStatus } from '/@/api/alarm'

const emit = defineEmits(['onClose'])
const props = defineProps<{
    info:object,
    list:Array<object>,
    isShow:boolean,
    type:string,
    isSign:boolean
    }>()
// const imgList = ref(props.list)
const currentImg = ref()
const currentIndex = ref(0)
const imgSrcList = ref([{}])
const scaleNum = ref(1)
const restoreNum = ref(1)
watch(() => props.isShow, (newValue, oldValue) => {
  if (newValue) {
    imgSrcList.value = props.list
    // currentImg.value = imgSrcList.value[0]
  } else {
    imgSrcList.value = []
  }
})
watch(() => props.info, (newValue, oldValue) => {
  currentImg.value = newValue
  props.list.forEach((item, index) => {
    switch (props.type) {
      case 'point':
        if (item.name === newValue.name) {
          currentIndex.value = index
        }
        break
      case 'alarm':
        if (item.id === newValue.id) {
          currentIndex.value = index
        }
        break
      default:
        if (item.file_name === newValue.file_name) {
          currentIndex.value = index
        }
    }
    // if (props.type === 'alarm') {
    //   if (item.id === newValue.id) {
    //     currentIndex.value = index
    //   }
    // } else {
    //   if (item.file_name === newValue.file_name) {
    //     currentIndex.value = index
    //   }
    // }
  })
})
onMounted(() => {

})
function handleMarkImg () {
  Modal.confirm({
    title: () => '是否标记该图片误报?',
    onOk () {
      setAlarmStatus({ id: currentImg.value.id, marker_status: 0 }).then(res => {
        if (res.code === 0) {
          message.success('标记成功')
          imgSrcList.value.forEach((el, index) => {
            if (index === currentIndex.value) {
              imgSrcList.value.splice(index, 1)
              if (imgSrcList.value.length > currentIndex.value) {
                currentImg.value = imgSrcList.value[currentIndex.value]
              } else {
                if (imgSrcList.value.length === 0) {
                  emit('onClose', false)
                  return
                }
                currentImg.value = imgSrcList.value[imgSrcList.value.length - 1]
                currentIndex.value = imgSrcList.value.length - 1
              }
              console.log('删除图片后', imgSrcList.value)
            }
          })
        }
      })
    },
    onCancel () {
      console.log('Cancel')
    }
  })
}
function restoreImg () {
  scaleNum.value = 1
  restoreNum.value = 3
}
function scaleImg (type:string) {
  if (type === 'enlarge') {
    if (scaleNum.value > 2) {
      return
    }
    scaleNum.value += 0.2
    console.log('放大', scaleNum.value)
  } else {
    if (scaleNum.value < 0.8) {
      return
    }
    scaleNum.value -= 0.2
  }
}
function handlePreview () {
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value--
  if (currentIndex.value < 0) {
    currentIndex.value = 0
    message.warning('已是第一张图片')
  } else {
    currentImg.value = imgSrcList.value[currentIndex.value]
  }
}
function handleNext () {
  scaleNum.value = 1
  restoreNum.value = 3
  currentIndex.value++
  if (currentIndex.value > imgSrcList.value.length - 1) {
    currentIndex.value = imgSrcList.value.length - 1
    message.warning('已是最后一张图片')
  } else {
    currentImg.value = imgSrcList.value[currentIndex.value]
  }
}
function handleImgPreview (index:number) {
  currentIndex.value = index
  currentImg.value = imgSrcList.value[currentIndex.value]
}
function closeImgPreview () {
  currentImg.value = ''
  currentIndex.value = 0
  imgSrcList.value = []
  scaleNum.value = 1
  restoreNum.value = 1
  emit('onClose', false)
}

</script>
<style scoped>

.map-box{
  width: 100%;
  height: 200px;
}
.img-panel-wrapper{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #1c1c1c;
    z-index: 9999;
}
.img-info-box{
  width: 100%;
  height: calc(100% - 180px);
}
.img-list-box{
  width: 100vw;
  height: 180px;
  border-top: 1px solid #000000;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}
.tool-box{
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.list-scroll-box{
  width: 70%;
  height: 100%;
  overflow: hidden;
  overflow-x: auto;
  padding-bottom: 10px
}
.preview-box{
  width: 80%;
  height: 100%;
  background-color: #000000;
  position: relative;
  overflow: hidden;
}
.img-preview-info-box{
  width: 20%;
  height: 100%;
  position: relative;
  padding: 20px 30px;
  box-sizing: border-box;
}
.preview-btn{
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.next-btn{
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}
.viewer-list{
  overflow: hidden;
  box-sizing: border-box;
  -webkit-filter: brightness(60%); /* Chrome, Safari, Opera */
  filter:brightness(60%);
  flex-shrink:0;
}
.is-active-img{
  border: 2px solid #1088f2;
  border-radius: 10px;
  -webkit-filter: brightness(100%); /* Chrome, Safari, Opera */
  filter:brightness(100%)
}
.close-btn{
  position: absolute;
  right: 20px;
  top: 30px;
}
</style>
